import React from "react";
import { OI } from "../onam/mark";
import { FEATURES } from "../onam/features";

const BaseBackIcon = ({ className, onClick }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      d="M8.1851 12.5998L9.3827 13.6486C9.49531 13.7552 9.56228 13.9013 9.56957 14.0562C9.57685 14.211 9.52389 14.3627 9.42177 14.4794C9.31966 14.5961 9.17634 14.6688 9.02185 14.6821C8.86736 14.6955 8.71371 14.6485 8.5931 14.551L6.1931 12.451C6.12886 12.3947 6.07738 12.3253 6.04211 12.2475C6.00684 12.1697 5.9886 12.0852 5.9886 11.9998C5.9886 11.9144 6.00684 11.8299 6.04211 11.7521C6.07738 11.6743 6.12886 11.6049 6.1931 11.5486L8.5931 9.4486C8.71371 9.35114 8.86736 9.30415 9.02185 9.31749C9.17634 9.33084 9.31966 9.40347 9.42177 9.52017C9.52389 9.63686 9.57685 9.78856 9.56957 9.94345C9.56228 10.0983 9.49531 10.2444 9.3827 10.351L8.1851 11.3998H12.5999C12.759 11.3998 12.9116 11.463 13.0242 11.5755C13.1367 11.6881 13.1999 11.8407 13.1999 11.9998C13.1999 12.1589 13.1367 12.3115 13.0242 12.4241C12.9116 12.5366 12.759 12.5998 12.5999 12.5998H8.1851ZM21.5999 16.7998C21.5999 17.4363 21.347 18.0468 20.897 18.4969C20.4469 18.9469 19.8364 19.1998 19.1999 19.1998H4.7999C4.16338 19.1998 3.55293 18.9469 3.10285 18.4969C2.65276 18.0468 2.3999 17.4363 2.3999 16.7998V7.1998C2.3999 6.56329 2.65276 5.95284 3.10285 5.50275C3.55293 5.05266 4.16338 4.7998 4.7999 4.7998H19.1999C19.8364 4.7998 20.4469 5.05266 20.897 5.50275C21.347 5.95284 21.5999 6.56329 21.5999 7.1998V16.7998ZM14.3999 17.9998V5.9998H4.7999C4.48164 5.9998 4.17642 6.12623 3.95137 6.35128C3.72633 6.57632 3.5999 6.88154 3.5999 7.1998V16.7998C3.5999 17.1181 3.72633 17.4233 3.95137 17.6483C4.17642 17.8734 4.48164 17.9998 4.7999 17.9998H14.3999Z"
      fill="white"
    />
  </svg>
);

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "back" glyph instead (onam/mark.tsx). */
const BackIconSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="back" size={props.size || 18} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseBackIcon {...props} />
  );
export default BackIconSkin;
